import React from 'react';
import WorkExerpt from '../components/WorkExerpt';
import works from '../data/works';
import {ReactComponent as Pen} from "../media/graphics/pen.svg";

function Work() {

    return (
        <main className="work page">
            <section className="work-list-container section-wrapper intro">
                <h1><span>Work<Pen className="pen"/></span></h1>
                

                {works.map((workObj, i) => {
                    return <WorkExerpt 
                    key={i} 
                    workObj={workObj} 
                    />
                })}
            </section>
            
        </main>
    )
}

export default Work
